import axios from "../util/axios";
import prepareChatImage from "../util/chatImage";
import clientId from "../util/chatMessageId";

function release(image) {
  clearTimeout(image.timer);
  if (image.preview_url) URL.revokeObjectURL(image.preview_url);
}

export default {
  state: () => ({ pendingImages: [] }),
  mutations: {
    discardChatImage(state, id) {
      const index = state.pendingImages.findIndex(image => image.client_msg_id === id);
      if (index !== -1) release(state.pendingImages.splice(index, 1)[0]);
    },
    settleChatImage(state, message) {
      const index = state.pendingImages.findIndex(image =>
        image.sender_id == message.sender_id && image.reciver_id == message.reciver_id &&
        (image.client_msg_id === message.client_msg_id || (image.img && image.img === message.img)));
      if (index !== -1) release(state.pendingImages.splice(index, 1)[0]);
    },
    clearChatImages(state) {
      state.pendingImages.forEach(release);
      state.pendingImages = [];
    },
    failChatImage(state, response) {
      const image = state.pendingImages.find(item => item.client_msg_id === response.client_msg_id);
      if (!image) return;
      clearTimeout(image.timer);
      image.status = "failed";
      image.error_key = response.error_key || "chat.sendFailed";
    },
  },
  actions: {
    sendChatImage({ state, rootState, dispatch }, { file, receiver_id }) {
      if (!file || !receiver_id || !rootState.User.isLogin) return false;
      const image = {
        client_msg_id: clientId(), sender_id: rootState.User.id, reciver_id: receiver_id,
        type: "img", img: "", file, preview_url: URL.createObjectURL(file),
        status: "queued", progress: 0, error_key: "", create_time: Math.floor(Date.now() / 1000),
        ndate: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      };
      state.pendingImages.push(image);
      return dispatch("retryChatImage", image.client_msg_id);
    },
    async retryChatImage({ state, rootState, dispatch }, id) {
      const image = state.pendingImages.find(item => item.client_msg_id === id);
      if (!image || ["uploading", "sending"].includes(image.status)) return false;
      const token = localStorage.getItem("token");
      const active = () => state.pendingImages.includes(image) && rootState.User.isLogin &&
        rootState.User.id == image.sender_id && localStorage.getItem("token") === token;
      clearTimeout(image.timer);
      image.error_key = "";
      try {
        if (!image.img) {
          image.status = "uploading";
          image.file = await prepareChatImage(image.file);
          if (!active()) return false;
          const response = await axios.post_form("/member/chat_file/upload", {
            file: image.file, receiver_id: image.reciver_id,
          }, { onUploadProgress(event) {
            if (active() && event.total) image.progress = Math.round(event.loaded * 100 / event.total);
          } });
          if (!active()) return false;
          if (response.data.status != 200 || !response.data.data || !response.data.data.file_id) {
            const error = new Error("Upload rejected");
            error.error_key = response.data.status == 401 ? "chat.loginExpired" :
              (response.data.data && response.data.data.error_key) || "chat.uploadFailed";
            throw error;
          }
          image.img = response.data.data.file_id;
        }
        if (!active()) return false;
        image.status = "waiting";
        return await dispatch("resumeChatImages");
      } catch (error) {
        if (active()) {
          image.status = "failed";
          image.error_key = error.error_key || "chat.uploadFailed";
        }
        return false;
      }
    },
    async resumeChatImages({ state, rootState, dispatch }) {
      for (const image of state.pendingImages.slice()) {
        if (!rootState.User.isLogin || image.status !== "waiting" || !image.img) continue;
        image.status = "sending";
        let sent = false;
        try {
          sent = await dispatch("wssend", {
            opt: 1, address: image.reciver_id, img: image.img, type: "img", origin: true,
            client_msg_id: image.client_msg_id,
          });
        } catch (error) { sent = false; }
        if (!state.pendingImages.includes(image) || image.status !== "sending") continue;
        if (!sent) { image.status = "waiting"; continue; }
        image.timer = setTimeout(() => {
          if (state.pendingImages.includes(image) && image.status === "sending") {
            image.status = "failed";
            image.error_key = "chat.confirmTimeout";
          }
        }, 15000);
      }
    },
    pauseChatImages({ state }) {
      state.pendingImages.forEach(image => {
        if (image.status === "sending") {
          clearTimeout(image.timer);
          image.status = "waiting";
        }
      });
    },
  },
};
